import React from 'react'
import classNames from 'classnames'
import classes from './PlansComponent.module.css'
import { SubscriptionLoader } from '../loaders/SubscriptionLoader'
import { usePlans, BillingModes } from '../../hooks/usePlans'
import SubscriptionCard from '../Cards/SubscriptionCard/SubscriptionCard'
import { OptionToggle } from '../OptionToggle/OptionToggle'
import Carousel from '../Carousel/Carousel'

export function IndividualPlans({ className, onSelect }) {
    const {
        isFetching,
        changeBillingMode,
        billingMode,
        plans,
        onSelectPlan,
    } = usePlans()

    const options = {
        left: BillingModes.Annually,
        right: BillingModes.Monthly,
    }

    const content = isFetching
        ? [1, 2].map(i => <SubscriptionLoader key={i} />)
        : plans.map(plan => (
              <SubscriptionCard
                  key={plan.subid}
                  title={plan.title}
                  amount={plan.amount}
                  cycle={plan.cycle}
                  description={plan.description}
                  features={plan.features}
                  onSelect={() =>
                      !!onSelect ? onSelect(plan) : onSelectPlan(plan)
                  }
                  className={classes.planItem}
              />
          ))

    return (
        <div className={classNames(classes.plans, className)}>
            <OptionToggle
                options={options}
                activeOption={billingMode}
                onChangeOption={changeBillingMode}
                className={classes.billingMode}
            />
            <div className={classes.plansGrid}>{content}</div>
            <div className={classes.plansCarousel}>
                <Carousel
                    slideClassName={classes.planSlideWrapper}
                    dots
                    dotBg={'#EB6324'}
                    dotClass={classes.dot}
                >
                    {content}
                </Carousel>
            </div>
        </div>
    )
}
